import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useRef, useState, useEffect } from 'react';
import { HelpModalBody } from './HelpModalBody.js';
import { i18n } from '../../i18n/translate.js';
import { copyTextFromElement } from '../../utils/CopyUtil.js';
import { getOS } from '../../utils/getOS.js';
var HelpModal = function HelpModal(_ref) {
  var helpMessage = _ref.helpMessage,
    helpMessageEnabled = _ref.helpMessageEnabled,
    isFoundry = _ref.isFoundry,
    showHelpModal = _ref.showHelpModal,
    toggleHelpModal = _ref.toggleHelpModal,
    user = _ref.user,
    copyDone = _ref.copyDone;
  var containerRef = useRef(null);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    copySuccess = _useState2[0],
    setCopySuccess = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setLoading = _useState4[1];
  useEffect(function () {
    // make sure the DOM node is assigned to the containerRef.current property
    if (isLoading && containerRef !== null && containerRef !== void 0 && containerRef.current) setLoading(false);
  }, [isLoading]);
  var copyToClipboard = function copyToClipboard() {
    var success = copyTextFromElement('#help-modal-info', document.getElementById('help-modal'));
    setCopySuccess(success);
    if (copyDone === false) {
      copyDone = true;
      setTimeout(function () {
        return setCopySuccess(false);
      }, 2000);
    }
  };
  var getUserTypes = function getUserTypes(_ref2) {
    var user_types = _ref2.user_types,
      rule_sets = _ref2.rule_sets;
    var values = [];
    if (user_types) {
      values = Object.keys(user_types);
    } else if (rule_sets) {
      values = rule_sets.map(function (rs) {
        return rs.label;
      });
    }
    return values.join(', ');
  };
  var cookieEnabled = typeof window !== 'undefined' && window.navigator.cookieEnabled ? i18n.t('enabled') : i18n.t('disabled');
  var currentUrl = typeof window !== 'undefined' ? window.location.href : '';
  var userData = (user === null || user === void 0 ? void 0 : user.attributes) || user;
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: "foundry"
  }, /*#__PURE__*/React.createElement(HelpModalBody, {
    cookieEnabled: cookieEnabled
    /* @ts-ignore */,
    copySuccess: copySuccess,
    copyToClipboard: copyToClipboard,
    currentUrl: currentUrl,
    getOS: getOS
    /* @ts-ignore */,
    getUserTypes: getUserTypes,
    helpMessage: helpMessage,
    helpMessageEnabled: helpMessageEnabled,
    isFoundry: isFoundry,
    ref: !isLoading ? containerRef.current : null,
    showHelpModal: showHelpModal,
    toggleHelpModal: toggleHelpModal
    /* @ts-ignore */,
    userData: userData
  }));
};
HelpModal.displayName = "HelpModal";
export { HelpModal };